import { render, staticRenderFns } from "./new_edit_academic_vime_activity.vue?vue&type=template&id=150e9c54"
import script from "./new_edit_academic_vime_activity.vue?vue&type=script&lang=js"
export * from "./new_edit_academic_vime_activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports